export default "__VITE_ASSET__DFlu2PR9__"